import { Link } from "wouter";
import type { BlogPostSummary } from "@/api/blog";

export default function RelatedPosts({ posts }: { posts: BlogPostSummary[] }) {
  if (posts.length === 0) {
    return null;
  }

  return (
    <section className="mt-20 pt-12 border-t border-[rgba(17,17,17,0.08)]">
      <h2 className="font-display text-xl sm:text-2xl font-semibold tracking-tight mb-7 text-brand-navy">
        Related posts
      </h2>
      <div className="grid gap-5 sm:grid-cols-3">
        {posts.map((post) => (
          <Link
            key={post.slug}
            href={`/blog/${post.slug}`}
            className="home-card rounded-2xl p-5 hover:shadow-[0_20px_50px_rgba(17,17,17,0.08)] transition-shadow"
          >
            <p className="font-display font-medium tracking-tight leading-snug mb-2.5 text-brand-navy">
              {post.title}
            </p>
            <p className="text-sm text-[#666666] leading-relaxed line-clamp-3">{post.excerpt}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}
